<template>
    <div>
        <form name="pay-form" ref="pay-form" target="_self" method="post" style="display:none">
            <input name="x_login" ref="page-id" type="hidden">
            <input name="x_amount" :value="balanceWithTip" type="hidden">
            <input name="x_fp_sequence" ref="sequence-number" type="hidden">
            <input name="x_fp_timestamp" ref="timestamp" type="hidden">
            <input name="x_fp_hash" ref="hash" type="hidden">
            <input name="x_first_name" value="" type="hidden">
            <input name="x_last_name" value="" type="hidden">
            <input name="x_invoice_num" ref="invoice-number" type="hidden">
            <input name="x_description" ref="description" type="hidden">
            <input name="x_show_form" value="PAYMENT_FORM" type="hidden">
        </form>
    </div>
</template>

<script>
    import axios from "axios";
    import { mapGetters, mapState, mapMutations } from "vuex";
    import sessionDataStorage from "../mixins/session-storage";
    import { keynames } from "../constants/keynames";

    export default {
        name: "CreditCardPayeezy",
        mixins: [sessionDataStorage],
        computed: {
            ...mapState({
                session: state => state.session
            }),
            ...mapGetters([
                "balanceWithTip"
            ])
        },
        methods: {
            ...mapMutations([
                "setLoadingStatus"
            ]),
        },
        created() {
            // This is assigned value before user is navigated to the processor's site.
            // This will allow the app to load the check again when the user taps the
            // back button instead of paying the check.
            const checkUrlBeforePayment = this.getSessionData(keynames.checkUrl);

            if (checkUrlBeforePayment !== null) {
                this.removeSessionData(keynames.checkUrl);
                this.$router.push(checkUrlBeforePayment);
                return;
            }

            const url = "/payeezy/paymentinformation/" + this.balanceWithTip + "/" + this.session.siteId + "/"
                + this.session.accountId + "/" + this.session.checkId + "/" + this.session.expirationTicks

            axios.get(url)
                .then(response => {
                    if (response.data) {
                        this.paymentInfo = response.data;
                        this.$refs["pay-form"].action = this.paymentInfo.paymentPageUrl;
                        this.$refs["page-id"].value = this.paymentInfo.paymentPageId;
                        this.$refs["sequence-number"].value = this.paymentInfo.sequenceNumber;
                        this.$refs["timestamp"].value = this.paymentInfo.timestamp;
                        this.$refs["hash"].value = this.paymentInfo.hash;
                        this.$refs["invoice-number"].value = this.paymentInfo.invoiceNumber;
                        this.$refs["description"].value = this.paymentInfo.description;

                        this.setSessionData(keynames.checkUrl, "/landing/?s=" + this.session.siteId +
                            "&c=" + this.session.checkId + "&e=" + this.session.expirationTicks +
                            "&a=" + this.session.accountId);

                        this.$refs["pay-form"].submit();
                    }
                    else {
                        this.setLoadingStatus(false);
                        this.$router.push("/error/1024");
                    }
                })
                .catch(error => {
                    console.error("Error retrieving payment information - " + error);
                    this.setLoadingStatus(false);
                    this.$router.push("/error/1024");
                })
        },
        mounted() {
            this.setLoadingStatus(true);
        }
    }
</script>